import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { zIndex } from 'variables';
import GenericOverlay from './components/GenericOverlay';
import SideDrawer from './SideDrawer';

const StyledSideDrawer = styled(SideDrawer)`
    overscroll-behavior: contain;
    max-height: 100%;
    z-index: ${zIndex.modal};
`;

export default function SideDrawerWithOverlay({
    isOpen,
    overlayProps,
    children,
    ...restProps
}: {
    isOpen: boolean;
    children?: ReactNode;
    overlayProps?: any; // change to react props
}) {
    return (
        <>
            <StyledSideDrawer isOpen={isOpen} {...restProps}>
                {children}
            </StyledSideDrawer>
            <GenericOverlay isActive={isOpen} {...overlayProps} />
        </>
    );
}
